import Vue from 'vue';
import vuetify from './plugins/vuetify';

import VueResource from 'vue-resource';
import VueRouter from 'vue-router';
import VueSwal from 'vue-swal';
import VeeValidate from 'vee-validate';
import vSelect from 'vue-select';
import VueTheMask from 'vue-the-mask';
import VueMoney from 'v-money';
import VueAWN from 'vue-awesome-notifications';
import VueAWNOptions from './helpers/notifications/notification-options';
import { routes } from './routes/routes';
import Meta from 'vue-meta';
import BlockUI from 'vue-blockui';
import * as VueGoogleMaps from 'vue2-google-maps';
import AuthController from './controllers/AuthController';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import VueAnalytics from 'vue-analytics';
import JsonExcel from 'vue-json-excel';
import VueCordova from 'vue-cordova';
import Zendesk from '@dansmaculotte/vue-zendesk';

// set language to EN
import lang from 'element-ui/lib/locale/lang/pt-br';
import locale from 'element-ui/lib/locale';
import VueDataTables from 'vue-data-tables';
import Photoswipe from 'vue-pswipe';
import VueI18n from 'vue-i18n';

// CSS

import '@/assets/css/general.css';
import '@/assets/css/style.css';
import '@/assets/css/login.css';
import '@/assets/css/vue-datetime.css';
import 'vue-awesome-notifications/dist/styles/style.css';
import 'bootstrap/dist/css/bootstrap.css';
import '@/assets/css/override.css';
// JS
import { library } from '@fortawesome/fontawesome-svg-core';
import { faArrowAltCircleLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
// import './assets/css/style.css'
import Datetime from 'vue-datetime';

import messages from './resources/pt_BR';
import App from './App.vue';
import './registerServiceWorker';
import ImageUploader from 'vue-image-upload-resize';

import VueFormWizard from 'vue-form-wizard';
import 'vue-form-wizard/dist/vue-form-wizard.min.css';
// import LoadScript from "vue-plugin-load-script";

// Vue.use(LoadScript);
// Vue.loadScript("js/index.js");

Vue.use(VueFormWizard);

// Vue.use(Vuetify)
Vue.use(ImageUploader);

library.add(faArrowAltCircleLeft);
Vue.component('font-awesome-icon', FontAwesomeIcon);
// require("vue-awesome-notifications/dist/styles/style.css")

Vue.component('downloadExcel', JsonExcel);

Vue.mixin({
  data: function () {
    return {
      get config() {
        return {};
      },
    };
  },
});

Vue.use(Zendesk, {
  key: 'd1d24da0-4836-4e8d-a514-bd3c92f1f5a8',
  disabled: false,
  hideOnLoad: false,
  settings: {
    webWidget: {
      offset: {
        mobile: {
          horizontal: '730px',
        },
      },
      color: {
        theme: '#FCFCFC',
      },
    },
  },
});

window.Vue = Vue;
window.$ = require('jquery/dist/jquery.js');
//LANGUAGE
locale.use(lang);

const i18n = new VueI18n({
  locale: 'pt_BR', // set locale
  messages,
});

Vue.use(VueI18n);
// Vue.use(Vuetify)
Vue.use(BlockUI);
Vue.use(VueCordova);
Vue.use(VueResource);
Vue.use(VueRouter);
Vue.use(Meta);
Vue.use(Datetime);
Vue.use(VueAWN, VueAWNOptions);
Vue.use(VueSwal);
Vue.use(ElementUI);
Vue.use(VueDataTables);
Vue.use(VeeValidate);
Vue.use(VueTheMask);
Vue.use(VueMoney);
Vue.use(Photoswipe, {
  options: {
    index: 3,
    escKey: false,
    timeToIdle: 4000,
  },
});

//REGISTER COMPONENT
Vue.component('v-select', vSelect);

//VUE RESOURCES
Vue.http.options.root = `${process.env.VUE_APP_API_ROOT_URL}/api/v1`;

const router = new VueRouter({
  routes,
  mode: 'hash',
  scrollBehavior: (to, from, savedPosition) => {
    if (savedPosition) {
      return savedPosition;
    } else if (to.hash) {
      return {
        selector: to.hash,
      };
    } else {
      return { x: 0, y: 0 };
    }
  },
});

Vue.cordova.on('deviceready', () => {
  if (navigator.userAgent.match(/Android/i)) {
    window.VerifyAutomaticDateTimeZone.isAutomaticChecked(function (isIt) {
      if (isIt == 'true') {
        console.log('automaticChecked true');
      } else {
        console.log('automaticChecked false');
      }
    });
    let version = parseInt(window.device.version);
    // Foi feito dessa forma, para remediar um problema de imcompatibilidade
    // da biblioteca "cordova-plugin-background-mode" com as versões mais recentes do android (9.0 ou superior)
    if (version <= 8) {
      cordova.plugins.backgroundMode.setEnabled(true);
    }
  }
});

if (
  process.env.VUE_APP_API_ROOT_URL == 'https://api.usecargo.pickndrive.com.br'
) {
  Vue.use(VueAnalytics, {
    id: 'UA-121370439-2',
    router,
  });
}

//VUE RESOURCES INTERCEPTOR
Vue.http.interceptors.push((request, next) => {
  request.headers.set(
    'Authorization',
    'Bearer ' + localStorage.getItem('access_token')
  );
  request.headers.set('Accept', 'application/json');
  next(response => {
    if (response.status == 401 || response.status == 403) {
      let auth = new AuthController(null, router);
      auth.logout();
    }
  });
});

new Vue({
  el: '#app',
  i18n,
  router,
  vuetify,
  render: h => h(App),
  async mounted() {
    //let controller = new ConfigurationController(this.$resource)
    //let response = await controller.getConfigMaps()

    Vue.use(VueGoogleMaps, {
      load: {
        key: process.env.VUE_APP_KEY_GOOGLE_MAPS,
        libraries: 'places',
      },
    });
  },
});
